import { ChartLineUpIcon } from "@phosphor-icons/react";

import { Badge, classNames } from "@alpacahq/ui/old";

import { SealCheckIcon } from "~/v2/components/common";
import { ALGO_TRADER_PLUS_BENEFITS } from "../../const";
import type { MarketDataPlans } from "../../util";

interface BenefitsCardProps {
  className?: string;
  isYearly?: boolean;
  plans?: MarketDataPlans;
  isElite?: boolean;
  isBeingBilled?: boolean;
}

export const BenefitsCard = ({
  className,
  isYearly,
  plans,
  isElite,
  isBeingBilled,
}: BenefitsCardProps) => (
  <div
    className={classNames(
      "flex flex-col gap-4 rounded-lg border border-yellow-600 bg-[linear-gradient(106deg,rgba(255,252,216,0.65)_-38.69%,#FFF_97.09%)] p-4",
      className,
    )}
  >
    <div className="flex items-center justify-between gap-2">
      <div className="flex items-center justify-start gap-2">
        <ChartLineUpIcon size={26} />
        <h2 className="m-0 p-0 text-left font-semibold text-gray-800 text-lg">
          Algo Trader Plus
        </h2>
      </div>
      <div className="flex xs:flex-row flex-col items-end xs:items-center xs:justify-end gap-2">
        {!isBeingBilled && isElite && <Badge variant="v2/emerald">Free</Badge>}
        {isBeingBilled && plans && (
          <p className="m-0 p-0 text-gray-800">
            <span className="font-medium font-mono text-xl">
              {isYearly
                ? plans.yearly.displayPrice
                : plans.monthly.displayPrice}
            </span>
            <span className="font-mono text-base">
              {"/"}
              {isYearly ? "y" : "mo"}
            </span>
          </p>
        )}
      </div>
    </div>

    <ul className="m-0 flex xs:grid xs:grid-cols-2 flex-col gap-4 p-0">
      {ALGO_TRADER_PLUS_BENEFITS.map((benefit) => (
        <li key={benefit} className="flex items-center gap-2">
          <SealCheckIcon />
          <p className="m-0 p-0 text-gray-700 text-sm">{benefit}</p>
        </li>
      ))}
    </ul>
  </div>
);
